import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomerService } from "src/app/services/customer.service";

export interface CustomerNameUpdateHistoryModel {
    customerName: string;
    date: string;
}

@Component({
    selector: 'customer-name-update-history-model',
    templateUrl: './customer-name-update-history-model.component.html',
    styleUrls: ['./customer-name-update-history-model.component.scss']
})
export class CustomerNameUpdateHistoryModelComponent implements OnInit {

    @Input() customer: any;

    historyListAll: CustomerNameUpdateHistoryModel[] = [];
    historyList: CustomerNameUpdateHistoryModel[] = [];
    collectionSizeHistory: number = 0;
    pageHistory: number = 1;
    pageSizeHistory: number = 10;

    constructor(
        public activeModal: NgbActiveModal,
        private customerService: CustomerService
    ) { }

    ngOnInit(): void {
        this.getCustomerNameUpdateHistory();
    }

    getCustomerNameUpdateHistory() {
        this.customerService
            .getCustomerNameUpdateHistory(this.customer.id)
            .subscribe((res: any) => {
                const result = res?.result || res || [];
                this.historyListAll = result || [];
                this.historyList = result || [];
                this.collectionSizeHistory = result?.length || 0;
            }, (error) => {
                this.historyListAll = [];
                this.historyList = [];
                this.collectionSizeHistory = 0;
            });
    }

    resetPage() {
        this.pageHistory = 1;
    }

    closeModal() {
        this.activeModal.close();
    }
}
